import { render, staticRenderFns } from "./ReceivedStatementReport.vue?vue&type=template&id=c88d6aa6&scoped=true"
import script from "./ReceivedStatementReport.vue?vue&type=script&lang=js"
export * from "./ReceivedStatementReport.vue?vue&type=script&lang=js"
import style0 from "./ReceivedStatementReport.vue?vue&type=style&index=0&id=c88d6aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88d6aa6",
  null
  
)

export default component.exports